import PropTypes from "prop-types";

const ContentStorePropTypes = PropTypes.shape({
  data: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        title: PropTypes.string,
        description: PropTypes.string,
        tags: PropTypes.arrayOf(PropTypes.string),
        url: PropTypes.string,
        icon: PropTypes.string,
        image: PropTypes.string,
        pageSettings: PropTypes.shape({
          web: PropTypes.shape({
            order: PropTypes.number,
            featured: PropTypes.bool,
            featuredOrder: PropTypes.number
          })
        }),
        pageSettingsJson: PropTypes.string,
        featuredForTags: PropTypes.arrayOf(PropTypes.string)
      })
    )
  ]),
  loadingStatus: PropTypes.string,
  load: PropTypes.func
});

const AutoCompletePropTypes = PropTypes.shape({
  data: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  keyword: PropTypes.string,
  isFocused: PropTypes.bool,
  activeIndex: PropTypes.number,
  isShow: PropTypes.bool,
  load: PropTypes.func,
  clear: PropTypes.func,
  updateKeyword: PropTypes.func,
  updateIsFocused: PropTypes.func,
  updateActiveIndex: PropTypes.func
});

const BaseTagStorePropTypes = PropTypes.shape({
  baseTag: PropTypes.string,
  updateBaseTag: PropTypes.func
});

export { ContentStorePropTypes, AutoCompletePropTypes, BaseTagStorePropTypes };
